export const LOGO_OPTIONS = [
  "🐕", "🦴", "🐾", "🐈", "🐱", "🧶", "🎨", "✂️", "🧵", "💎", "🌟", "🌱", "🌿", "🌻", "🚜",
  "⚡", "🔥", "🚀", "🏆", "💪", "😎", "🦁", "🐯", "🦊", "🐢", "🦄", "🌈", "💰", "🎯", "👑",
];

export const BRAND_COLORS = [
  { id: "sky", name: "Sky", bg: "#0EA5E9" },
  { id: "violet", name: "Violet", bg: "#8B5CF6" },
  { id: "pink", name: "Pink", bg: "#EC4899" },
  { id: "green", name: "Green", bg: "#10B981" },
  { id: "orange", name: "Orange", bg: "#F97316" },
  { id: "red", name: "Red", bg: "#EF4444" },
  { id: "navy", name: "Navy", bg: "#1E3A8A" },
  { id: "gold", name: "Gold", bg: "#F59E0B" },
];

export const NAME_IDEAS = {
  dog_walker: ["Happy Paws", "Wag Squad", "Leash Legends", "Pup Patrol"],
  babysitter: ["Happy Helpers", "Giggle Squad", "Little Stars", "Playtime Pals"],
  craft_maker: ["Sparkle Studio", "Bead Boss", "Crafty Corner", "Made by Me"],
  lawn_mower: ["Green Machine", "Mow Bros", "Yard Stars", "Grass Masters"],
};

export const defaultBrand = (biz, playerName) => ({
  name: `${playerName}'s ${biz.name}`,
  logo: biz.emoji,
  color: null,
});
